export const COLOR_IN_PALETTE = "ColorInPalette";
export const COLOR_PALETTE = "ColorPalette";
export const PRINT_COLOR = "PrintDesignColor";
export const COLOR_PALETTE_ENFORCED = "ColorPaletteRuleTypes:Enforced";
export const COLOR_PALETTE_OFF = "ColorPaletteRuleTypes:Off";

/**
 * Checks if the node type is PrintDesignColor or ColorInPalette
 */
export function isPrintOrPaletteColor(type: string): boolean {
	return type == PRINT_COLOR || type == COLOR_IN_PALETTE;
}

/**
 * Checks if the node type is ColorInPalette
 */
export function isPaletteColor(type: string): boolean {
	return type == COLOR_IN_PALETTE;
}

/**
 * Checks if colorPaletteRule is Enforced
 */
export function isColorPaletteRuleEnforced(rule: string): boolean {
	return rule == COLOR_PALETTE_ENFORCED;
}

/**
 * Checks if colorPaletteRule is Enforced or Enabled
 */
export function isColorPaletteRuleEnforcedOrEnabled(rule: string): boolean {
	return rule != COLOR_PALETTE_OFF;
}
